import { render, staticRenderFns } from "./CollectMeeting.vue?vue&type=template&id=2ac50af0&scoped=true"
import script from "./CollectMeeting.vue?vue&type=script&lang=js"
export * from "./CollectMeeting.vue?vue&type=script&lang=js"
import style0 from "./CollectMeeting.vue?vue&type=style&index=0&id=2ac50af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac50af0",
  null
  
)

export default component.exports